import React from 'react';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import styles from './PopupCloseButton.module.scss';

const PopupCloseButton = ({id, closePopup, closeButtonClassName, closeButtonDimension, closeButtonLabel}) => (
	<Button id={id} onClick={closePopup} classNames={cn(styles['popup__close'], closeButtonClassName)}>
		{closeButtonLabel}
		<Icon name="close" width={closeButtonDimension?.width || 16} height={closeButtonDimension?.height || 16} />
	</Button>
);

export default PopupCloseButton;
